module.exports = __webpack_public_path__ + "img/look1.659cd354.png";